export default "__VITE_ASSET__BTWCZIrl__"